import axios from "axios";
import schedules from "../../models/horarios/schedules";
import segments from "../../models/gestionTiempos/segment";
import numSequence from "../../models/gestionTiempos/numSequence";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getSchedules() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/horarios`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return schedules.fromJson(item);
        });
      });
  }

  getSegment(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let horarioId = data;

    return axios
      .get(`${url}/segmhorario/${horarioId}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return segments.fromJson(item);
        })
      );
  }

  getSequence(horarioId, segmid) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/numsecuencia/${horarioId}&${segmid}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return numSequence.fromJson(item);
        })
      );
  }
}
export default service;
